import type { Props as SelectorProps } from './Selector';

export const getDefaultAuthId = (
  props: SelectorProps,
  { canUseStale }: { canUseStale: boolean } = { canUseStale: false }
) => {
  const { node, auths, isAutoSelectionEnabled } = props;

  if (isAutoSelectionEnabled && !node.authentication_id) {
    const nonStaleAuths = auths.filter(auth => !auth.isStale || canUseStale);
    if (nonStaleAuths.length > 0) {
      return nonStaleAuths[0].id;
    }
  }
  return null;
};
